import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {debounceTime} from 'rxjs/operators';

@Component({
    selector: 'pv-custom-list-filters',
    templateUrl: './custom-list-filters.component.html',
    styleUrls: ['./custom-list-filters.component.scss'],
    standalone: false
})
export class CustomListFiltersComponent implements OnInit {
  @Input() filters: Array<{
    key: string;
    label: string;
    type: 'text' | 'select';
    placeholder?: string;
    options?: Array<{value: any, label: string}>;
  }> = [];

  @Output() filterChange = new EventEmitter<any>();

  filtersForm: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit() {
    const formControls = {};

    this.filters.forEach(filter => {
      formControls[filter.key] = [''];
    });

    this.filtersForm = this.fb.group(formControls);

    this.filtersForm.valueChanges
      .pipe(debounceTime(300))
      .subscribe(values => {
        this.filterChange.emit(values);
      });
  }

  resetFilters() {
    this.filtersForm.reset();
    this.filterChange.emit({});
  }
}
